import auth from "./authSlice";
import publisher from "./publisherSlice";
import settlement from "./settlementSlice";
import transaction from "./transactionSlice";
import currency from "./currencySlice";
import onboarding from "./onboardingSlice";
const rootReducer = {
  auth,
  publisher,
  settlement,
  transaction,
  currency,
  onboarding,
};

export default rootReducer;
